<script>
  import Link from "../shared/Link.svelte";
  import LessonList from "./LessonList.svelte";
  import News from "../shared/News.svelte";
  import { _ } from "svelte-i18n";
</script>

<div class="home">
  <p>
    {$_("lesson_page.p-0")}
  </p>
  <p>
    {$_("lesson_page.p-1")}
  </p>
  <ul>
    <li>{$_("lesson_page.li-0")}</li>
    <li>{$_("lesson_page.li-1")}</li>
    <li>{$_("lesson_page.li-2")}</li>
    <li>{$_("lesson_page.li-3")}</li>
    <li>{$_("lesson_page.li-4")}</li>
  </ul>
  <p>
    {$_("lesson_page.p-2")} <Link target="https://github.com/Totemi1324/TSPquantum" newPage={true}>{$_("lesson_page.Link")}</Link>.
  </p>
  <strong>{$_("lesson_page.strong")}</strong>
  <hr />
  <h2>{$_("lesson_page.h2-0")}</h2>
  <LessonList lesson_ids={["BxESn", "Z30Ce"]} />
  <h2>{$_("lesson_page.h2-1")}</h2>
  <LessonList lesson_ids={["m2MJl", "xR66u"]} />
  <h2>{$_("lesson_page.h2-2")}</h2>
  <LessonList lesson_ids={["yV8O6", "0nRrT", "EFTOp", "m9UPL"]} />
  <h2>{$_("lesson_page.h2-3")}</h2>
  <LessonList lesson_ids={["okhMZ", "_Z9Gv", "ufr4r"]} />
  <h2>{$_("lesson_page.h2-4")}</h2>
  <LessonList lesson_ids={["U7uiF"]} />
</div>

<style>
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
  h2 {
    margin-top: 30px;
    background: -webkit-linear-gradient(90deg, #2eb6e8, #80f1ef);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
